import React from 'react'
import { styled } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { formatNumber } from 'utils/numbers'

const Container = styled('article')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  padding: '15px 10px',
  borderBottom: '1px solid #DFDFDF',
}))

const Chip = styled('span')(() => ({
  alignSelf: 'flex-start',
  fontSize: 11,
  fontWeight: 600,
  color: '#fff',
  background: '#31ADE3',
  borderRadius: 20,
  padding: '1px 9px',
}))

const Nome = styled('h1')(() => ({
  fontSize: 14,
  color: '#0F3444',
  fontWeight: 500,
  margin: 0,
  fontFamily: 'monospace',
}))

const Linha = styled('div')(() => ({
  display: 'flex',
  gap: 6,
  fontSize: 14,
  color: '#6f7f88',
}))

export const ResgateRow = ({ resgate }) => {
  const { t, i18n } = useTranslation()
  return (
    <Container>
      <Chip>{t('resgatesLbc.origemLbc')}</Chip>
      <Nome>{resgate.codigo || `#${resgate.id}`}</Nome>
      <Linha>
        <span>{t('creditosDeBiodiversidade.ecorregioao')}:</span>
        <span>{resgate.ecorregiao}</span>
      </Linha>
      <Linha>
        <strong>{t('resgatesLbc.disponivel')}</strong>
        <span>
          {formatNumber(resgate.quantidadeDisponivel, i18n.language)} / {formatNumber(resgate.quantidadeTotal, i18n.language)}
        </span>
      </Linha>
    </Container>
  )
}

export default ResgateRow
